import { userPlaceholderIcon } from "assets/images";
import { TextArea, timeFormat } from "common/InputForm";
import React, { useEffect, useRef, useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoImage } from "react-icons/io5";
import { BsFillSendFill, BsThreeDots } from "react-icons/bs";
import { Link, useSearchParams } from "react-router-dom";
import { decryptData } from "utils/dataCipher";
import { dateShow } from "utils/dateFormat";
import { socket } from "utils/socket";
import { toastMessage } from "utils/toastMessage";
import FileUpload from "./FileUpload";
import moment from "moment";
import "./Chat.scss";

const Chat = () => {
  const [searchParam] = useSearchParams();
  const chatEndRef = useRef(null);
  let categoryData = searchParam.get("info") || {};
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [imageModal, setImageModal] = useState(false);
  // const [file, setFile] = useState({ attachment: "" });
  // const [attachment, setAttachment] = useState([]);
  const adminDetails = localStorage.getItem("adminInfo");
  const parsedAdminDetails = adminDetails ? JSON.parse(adminDetails) : null;
  const adminId = parsedAdminDetails?._id || "";
  // console.log('messages', messages)
  let chatDetails;
  if (Object.keys(categoryData).length) {
    chatDetails = decryptData(categoryData);
  }
  // console.log('chatDetails', chatDetails)
  // console.log('attachment', attachment)

  const sendMessage = (attachment) => {
    // console.log('attachment out side', attachment)

    if (!inputMessage.trim() && attachment.length === 0) {
      // toastMessage('Please enter a message or attach a file', 'error', 'blankInput');
      return;
    }
    // console.log('attachment inside', attachment)
    let messageData = {};
    if (attachment?.length > 0) {
      messageData = {
        messageType: "file",
        media: attachment,
      };
    } else if (inputMessage) {
      messageData = {
        messageType: "text",
        message: inputMessage,
      };
    }
    console.log("messageData", messageData);
    socket.emit("sendMessage", {
      roomId: chatDetails?.roomId,
      receiverId: chatDetails?.receiverId,
      ...messageData,
    });
    setInputMessage("");
    // setAttachment([])
  };
  //---------------socket------------------
  useEffect(() => {
    if (!socket) return;

    // Connect socket and emit `chatMessage`
    socket.connect();

    socket.emit("chatMessage", {
      roomId: chatDetails?.roomId,
    });
    // Listen for the message only if data was sent
    socket.on("receiveMessage", (data) => {
      if (data && data.result) {
        console.log("receiveMessage data", data);
        setMessages((prevMessages) => [...prevMessages, data?.result]);
      }
    });
    // Listen for received messages (list of messages)
    socket.on("receiveMessages", (data) => {
      setMessages(data?.result || []);
    });
    return () => {
      // Cleanup event listeners on unmount
      socket.off("receiveMessages");
      socket.off("receiveMessage");

      // Disconnect the socket when component unmounts
      socket.disconnect();
    };
  }, [chatDetails?.roomId]);
  // Scroll to the bottom whenever chatMessage changes (new messages)
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <div className="student_management">
      <div className="card">
        <div className="dashboard_title has_child">
          <h3>
            <Link to={-1}>
              <IoMdArrowRoundBack />
            </Link>
            Chat
          </h3>
          <div>
            <p>
              <b>Subject:</b> {chatDetails?.subject || "N/A"}{" "}
            </p>
            <p>
              <b>Description:</b> {chatDetails?.description || "N/A"}{" "}
            </p>
          </div>
          <div>
            <p>
              <b>Ticket Number:</b> {chatDetails?.ticketNumber || "N/A"}{" "}
            </p>
            <p>
              <b>Status:</b> {chatDetails?.ticketStatus || "N/A"}{" "}
            </p>
          </div>
          <div></div>
        </div>
        <div className="card-body chat_section">
          <section style={{ backgroundColor: "#F5F5F5" }}>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body">
                      <div className="row">
                        {/* Chat Messages */}
                        <div
                          className="chat-box"
                          style={{
                            position: "relative",
                            height: "400px",
                            overflowY: "auto",
                          }}
                        >
                          {
                            // messages?.map((msg) => {
                            messages &&
                              messages?.length > 0 &&
                              messages
                                .sort(
                                  (a, b) =>
                                    new Date(a.createdAt) -
                                    new Date(b.createdAt)
                                )
                                .map((msg, ind) => {
                                  const isAdmin =
                                    msg?.senderInfo?._id === adminId;
                                  return (
                                    <div
                                      key={msg?._id}
                                      className={`d-flex align-items-end mb-3 ${
                                        isAdmin
                                          ? "justify-content-end"
                                          : "justify-content-start"
                                      }`}
                                    >
                                      {/* Left-side avatar (Only for non-admin users) */}
                                      {!isAdmin && (
                                        <img
                                          src={
                                            msg.senderInfo.profile ||
                                            userPlaceholderIcon
                                          }
                                          alt="avatar"
                                          className="rounded-circle me-2"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                        />
                                      )}

                                      {/* Message Box */}
                                      <div
                                        className={`p-2 text-white rounded-3 shadow-sm ${
                                          msg.media.length > 1
                                            ? "multi_image"
                                            : ""
                                        } ${
                                          isAdmin
                                            ? "bg-primary text-end me-2"
                                            : "bg-secondary text-start ms-2"
                                        }`}
                                        style={{ maxWidth: "60%" }}
                                      >
                                        {/* Message Content Handling */}
                                        {msg.messageType === "file" &&
                                        msg.media.length > 0 ? (
                                          msg.media.map((data, ind) => (
                                            <img
                                              key={ind}
                                              src={data?.image}
                                              alt="Shared file"
                                              style={{
                                                maxWidth: "100%",
                                                borderRadius: "5px",
                                              }}
                                            />
                                          ))
                                        ) : (
                                          <p className="mb-1">{msg.message}</p>
                                        )}
                                        <pre className="text-muted">
                                          {" "}
                                          {moment(msg?.createdAt).fromNow()}
                                        </pre>
                                      </div>

                                      {/* Right-side avatar (Only for admin user messages) */}
                                      {isAdmin && (
                                        <img
                                          src={
                                            msg.senderInfo.profile ||
                                            userPlaceholderIcon
                                          }
                                          alt="avatar"
                                          className="rounded-circle ms-2"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                        />
                                      )}
                                    </div>
                                  );
                                })
                          }
                          <div ref={chatEndRef} />
                        </div>
                        {/* Input Field */}
                        {/* <div>
                                                    {attachment.length > 0 && (
                                                        <img className="w-25 h-25" src={attachment?.[0]?.image} alt="" />
                                                    )}
                                                </div> */}
                        {chatDetails?.ticketStatus === "open" && (
                          <div className="d-flex align-items-center p-3 border-top">
                            <img
                              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava6-bg.webp"
                              alt="avatar"
                              className="rounded-circle me-2"
                              style={{ width: "40px", height: "40px" }}
                            />
                            <div className="chat-input-wrap">
                              <textarea
                                type="text"
                                className="form-control form-control-lg input chat-input"
                                placeholder="Type a message..."
                                value={inputMessage}
                                onChange={(e) =>
                                  setInputMessage(e.target.value)
                                }
                                onKeyDown={(e) =>
                                  e.key === "Enter" && sendMessage()
                                }
                              />

                              <IoImage
                                className="attached_image"
                                onClick={() => setImageModal(true)}
                              />
                            </div>
                            <button
                              className="send-button ms-2 fs-3"
                              disabled={!inputMessage}
                              onClick={sendMessage}
                            >
                              <BsFillSendFill />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* -------image-upload-------------- */}
      <FileUpload
        show={imageModal}
        close={() => setImageModal(false)}
        sendMessage={sendMessage}
      />
    </div>
  );
};

export default Chat;
